function injectStyle (ssrContext) {
  require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-47ca1600\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader?{\"globalVars\":{\"museUiTheme\":\"'/usr/src/app/node_modules/muse-ui/src/styles/themes/variables/default.less'\"}}!../../../vue-loader/lib/selector?type=styles&index=0!./cardText.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./cardText.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-47ca1600\",\"hasScoped\":false}!../../../vue-loader/lib/selector?type=template&index=0!./cardText.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/muse-ui/src/card/cardText.vue
// module id = 659
// module chunks = 1